export default __webpack_public_path__ + "static/media/PRISPEK.8afe4bb2.png";